/**
 * Validates if a value exists in a list of items by checking against their ID.
 *
 * @param value - The value to check (typically an ID string)
 * @param items - Array of items, each with an 'id' property to check against
 * @param defaultValue - Value to return if validation fails (defaults to empty string)
 * @returns The original value if valid, otherwise the default value
 */
export const existsInItems = <T extends { id: string }>(
  value: string | undefined,
  items: T[] = [],
  defaultValue = ''
): string => {
  // If value is falsy or items is empty, return default
  if (!value || !items.length) return defaultValue;

  // Check if value exists in the items array
  const valueExists = items.some((item) => item.id === value);

  // Return original value if valid, otherwise default
  return valueExists ? value : defaultValue;
};
